import PropTypes from 'prop-types';
import React from 'react';
import ScenarioViewNavbar from '../../../components/ScenarioViewNavbar.react';
import ScenarioViewHeader from '../../../components/ScenarioViewHeader.react';
import ScenarioViewData from '../../../components/ScenarioViewData.react';
import ScenarioViewTabs from '../../../components/ScenarioViewTabs.react';

import { ScenarioPropTypes, LogsPropTypes, OrganizationPropTypes } from '../../../util/helpers/SharedPropTypes';

const ScenarioView = ({ scenario, logs, queries, organization }) => (
  <div className='scenarioView'>
    <ScenarioViewNavbar
      status={scenario.status}
      organizationId={scenario.organizationId}
      configs={scenario.parameters}
      savedScenarioId={scenario.id}
    />

    <ScenarioViewHeader
      name={scenario.name}
      status={scenario.status}
    />

    <ScenarioViewData scenario={scenario} queries={queries} />
    <br />

    <ScenarioViewTabs scenario={scenario} organization={organization} logs={logs} />
  </div>
);

ScenarioView.propTypes = {
  scenario: ScenarioPropTypes,
  logs: LogsPropTypes,
  queries: PropTypes.shape({
    targetUniverse: PropTypes.string,
    upliftScore: PropTypes.string,
  }),
  organization: OrganizationPropTypes,
};

export default ScenarioView;
